import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ViewDataState } from 'src/types/Domain';
import { BasicPivotItem } from 'src/worker/pivotWorker.types';
import { SankeyGroupedViewDefn } from 'configuration-schemas/viewdefns/viewdefn';
import { ErrorBoundaryComponentError } from 'src/components/ErrorBoundary/ErrorBoundary.slice';
import { ViewDefnState } from 'src/dao/tenantConfigClient';

export interface SankeyGroupedViewSlice {
  viewDefnState: ViewDefnState;
  sankeyDefn?: SankeyGroupedViewDefn;
  sankeyData: BasicPivotItem[];
  sankeyDataState: ViewDataState;
  detailData: BasicPivotItem[];
  detailDataState: ViewDataState;
  selectedMemberId?: string;
  title?: string;
}

const initialState: SankeyGroupedViewSlice = {
  viewDefnState: ViewDefnState.idle,
  sankeyData: [],
  sankeyDataState: ViewDataState.idle,
  detailData: [],
  detailDataState: ViewDataState.idle,
  title: '',
};

const sankeyGroupedViewSlice = createSlice({
  name: 'SankeyGroupedView',
  initialState,
  reducers: {
    requestConfig(state) {
      state.viewDefnState = ViewDefnState.loading;
    },
    receiveConfig(
      state,
      action: PayloadAction<{ sankeyDefn: SankeyGroupedViewDefn; title?: string }>
    ) {
      state.viewDefnState = ViewDefnState.loaded;
      state.sankeyDefn = action.payload.sankeyDefn;
      state.title = action.payload.title ?? state.title;
    },
    requestSankeyData(state) {
      state.sankeyDataState = ViewDataState.liveDataLoadingNoCache;
    },
    receiveSankeyData(state, action: PayloadAction<BasicPivotItem[]>) {
      state.sankeyData = action.payload;
      state.sankeyDataState = ViewDataState.liveDataReady;
    },
    requestDetailData(state, action: PayloadAction<string | undefined>) {
      state.detailDataState = ViewDataState.liveDataLoadingNoCache;
      state.selectedMemberId = action.payload;
    },
    receiveDetailData(state, action: PayloadAction<BasicPivotItem[]>) {
      state.detailData = action.payload;
      state.detailDataState = ViewDataState.liveDataReady;
    },
    receiveError(_state, _action: PayloadAction<ErrorBoundaryComponentError>) {
      return initialState;
    },
    cleanUp() {
      return initialState;
    },
  },
});

export const {
  requestConfig,
  receiveConfig,
  requestSankeyData,
  receiveSankeyData,
  requestDetailData,
  receiveDetailData,
  receiveError,
  cleanUp,
} = sankeyGroupedViewSlice.actions;

export default sankeyGroupedViewSlice.reducer;
